/** Playful status verbs shown while TAI is working on a reply. */
export const TAI_PROCESSING_VERBS = [
  'Clauding',
  'Vibing',
  'Pondering',
  'Orbiting',
  'Synthesizing',
  'Manifesting',
  'Ruminating',
  'Brewing',
  'Channeling',
  'Dreaming',
  'Computing',
  'Wandering',
  'Polishing',
  'Unraveling',
  'Connecting',
  'Illuminating',
] as const;

export interface ProcessingStatusHandle {
  show: () => void;
  hide: () => void;
}

export function createProcessingStatus(
  messagesEl: HTMLElement,
  assistantName = 'TAI',
  intervalMs = 2200,
): ProcessingStatusHandle {
  let statusEl: HTMLElement | null = null;
  let timer: ReturnType<typeof setInterval> | undefined;
  let verbIndex = 0;

  function pickNextVerb(): string {
    const verb = TAI_PROCESSING_VERBS[verbIndex % TAI_PROCESSING_VERBS.length];
    verbIndex += 1;
    return verb;
  }

  function render() {
    if (!statusEl) {
      return;
    }
    statusEl.textContent = `${assistantName} is ${pickNextVerb()}…`;
  }

  return {
    show() {
      if (statusEl) {
        return;
      }

      verbIndex = Math.floor(Math.random() * TAI_PROCESSING_VERBS.length);
      statusEl = document.createElement('div');
      statusEl.className = 'message processing';
      statusEl.setAttribute('role', 'status');
      statusEl.setAttribute('aria-live', 'polite');
      statusEl.setAttribute('aria-busy', 'true');
      render();
      messagesEl.appendChild(statusEl);
      messagesEl.scrollTop = messagesEl.scrollHeight;

      timer = setInterval(() => {
        render();
        messagesEl.scrollTop = messagesEl.scrollHeight;
      }, intervalMs);
    },
    hide() {
      if (timer) {
        clearInterval(timer);
        timer = undefined;
      }
      statusEl?.remove();
      statusEl = null;
    },
  };
}
